import React from "react";
import {
  Header,
  Loader,
  Icon
} from "semantic-ui-react";

const style = {
  mainSeg: {
    paddingTop: '15em',
    paddingBottom: '15em',
    textAlign: 'center'
  },
  progress: {
    marginTop: '3em',
    marginLeft: '3em',
    marginRight: '3em'
  }
};

export default (props) => {
  if(props.uploadProgress.isFinished){
    return (
      <div style={style.mainSeg}>
        <Header as='h1' icon>
          <Icon name='check circle outline' color='green' />
          Book Submitted!
          <Header.Subheader>Please wait for the response in your email.</Header.Subheader>
        </Header>
      </div>
    );
  }else if(props.uploadProgress.errorMsg){
    return (
      <div style={style.mainSeg}>
        <Header as='h1' icon>
          <Icon name='remove circle' color='red' />
          Error
          <Header.Subheader>{props.uploadProgress.errorMsg}. Please try again later</Header.Subheader>
        </Header>
      </div>
    );
  }else{
    return (
      <div style={style.mainSeg}>
        <Loader active inline='centered' size='large'>Uploading Files...</Loader>
      </div>
    );
  }
};
